import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { makeStyles, Typography, Box } from "@material-ui/core";

import { HorizontalTabs } from "../../../components/horizontalTabs";
import { OnboardingStatusTab } from "./tabs/onboardingStatus";
import { USER_ROLES } from "../../../services/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2.5)}px ${theme.spacing(4)}px`,
    height: "100%",
    boxSizing: "border-box",
  },
  title: {
    marginBottom: theme.spacing(1.6),
    fontWeight: 400,
  },
}));

export const TaskPage = () => {
  const classes = useStyles();
  const [searchParams, setSearchParams] = useSearchParams();
  const { cluster } = useSelector((state) => state.selectCSC);

  const TabComponent = [OnboardingStatusTab][+searchParams.get("tab")];

  const title = [cluster?.user_role === USER_ROLES.bop ? "OPEN TASKS" : "REALTIME STATUS"][
    searchParams.get("tab") || 0
  ];

  return (
    <Box className={classes.root}>
      <Typography className={classes.title} variant="h2">
        {title}
      </Typography>
      <HorizontalTabs
        tab={+searchParams.get("tab")}
        setTab={(tab) => setSearchParams({ tab })}
        tabNames={["Onboarding Status"]}
      />
      <TabComponent />
    </Box>
  );
};
